import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

export type State = {
	dialogOpen: boolean;
	errorMessage: string;
	isLoading: boolean;
};

type Actions = {
	setDialogOpen: (open: boolean) => void;
	setErrorMessage: (message: string) => void;
	openDialogWithError: (message: string) => void;
	setIsLoading: (isLoading: boolean) => void;
};

const useGlobalUXStore = create<State & Actions>((set) => ({
	dialogOpen: false,
	errorMessage: '',
	setDialogOpen: (dialogOpen) => set({ dialogOpen }),
	setErrorMessage: (errorMessage) => set({ errorMessage }),
	openDialogWithError: (errorMessage) => {
		set({ errorMessage });
		set({ dialogOpen: true });
	},
	isLoading: false,
	setIsLoading: (isLoading) => set({ isLoading }),
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('globalUXStore', useGlobalUXStore);
}

export default useGlobalUXStore;
